export default __webpack_public_path__ + "static/media/gallery_06.2d197520.jpg";